export const BOUNDS = [16.421111, 45.759722, 24.577081, 49.052222];
export const CAMERA_TARGET = {
	x: 2094175.9747152806,
	y: 0,
	z: -5951583.239421222
};
export const CAMERA_POSITION = {
	x: 1751554.4857860096,
	y: 103074.60774454838,
	z: -5739669.945872271
};
export const MIN_DISTANCE = 30000;
export const MAX_DISTANCE = 1000000;
export const START_DISTANCE = 30000;
export const FLY_TO_DISTANCE = 30000;
export const FLY_TO_ANGLE = Math.PI / 6;
export const MAX_POLAR_ANGLE = Math.PI / 2.02;
export const SCALAR_Y = 0.005;
export const MAX_OFFSET_Y = 20000;
export const MARKER_RADIUS = 500;
export const MARKER_POS_Y = 1500;
export const SELECTED_MARKER_POS_Y = 3000;

export const INTENSITY_COLOURS = {
	alacsony: 0xed5f5f,
	közepes: 0xff0000,
	magas: 0x8c0606
};

export const OUTER_R = MARKER_RADIUS;
export const INNER_R = OUTER_R * 0.9;
export const DISC_R = INNER_R * 0.6;
